import { render, staticRenderFns } from "./allShipmentsRow.vue?vue&type=template&id=60eefe3c"
import script from "./allShipmentsRow.vue?vue&type=script&lang=js"
export * from "./allShipmentsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports